import gql from 'graphql-tag'

const outboundReceiptsGetQuery = gql`
  query outboundReceiptsGet($offset: Int, $limit: Int, $criteria: Object, $sorting: Object, $nested: Boolean) {
    outboundReceiptsGet(input: { limit: $limit, offset: $offset, criteria: $criteria, sort: $sorting, nested: $nested })
      @rest(type: "OutboundReceiptsListResult", method: "POST", path: "outbound-receipt/list") {
      results
      paging
    }
  }
`

export default outboundReceiptsGetQuery
